import _typeof from "@babel/runtime/helpers/esm/typeof";

/**
 * Add aliases that point to another property on a reference object. The aliases will reflect any
 * changes to the reference object unless the alias itself is reassigned a new value.
 *
 * @param reference {object} The reference object that we will be aliasing values from.
 * @param aliases {function} A function that returns an object of aliases.
 * @param iReference {object} The sub-tree of the reference object for the given `depth`.
 * @param iAliases {object} The sub-tree of the aliases object for the given `depth`.
 * @param depth {array} An array of properties that represents the depth of the `iReference` and
 *     `iAliases` tree.
 */
export var alias = function alias(reference, aliases, iReference, iAliases, depth) {
  if (depth === void 0) {
    depth = [];
  }

  // eslint-disable-next-line no-param-reassign
  iAliases = iAliases || aliases(reference); // eslint-disable-next-line no-param-reassign

  iReference = iReference || reference; // Recursively iterate through the aliases, defining properties as we go

  Object.keys(iAliases).forEach(function (key) {
    var aliasValue = iAliases[key];

    if (_typeof(aliasValue) === 'object' && aliasValue !== null) {
      // Make sure object exists on the reference object
      if (!(key in iReference)) {
        // eslint-disable-next-line no-param-reassign
        iReference[key] = {};
      } // Recurse one level deeper


      alias(reference, aliases, iReference[key], aliasValue, depth.concat([key]));
    } else {
      Object.defineProperty(iReference, key, {
        enumerable: true,
        configurable: true,
        get: function get() {
          var now = aliases(reference);

          for (var i = 0; i < depth.length; i += 1) {
            now = now[depth[i]];
          }

          return now[key];
        },
        set: function set(value) {
          // Assigning a value to an alias removes the alias behavior.
          // The property should now behave like a normal value.
          Object.defineProperty(iReference, key, {
            value: value,
            writable: true
          });
        }
      });
    }
  });
};